var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":"","color":_vm.percentageChipColor,"text-color":"white"}},[_vm._t("before-percentage"),_vm._v(" "+_vm._s(_vm.value)+" % "),_vm._t("after-percentage")],2)}
var staticRenderFns = []

export { render, staticRenderFns }